import { AppSection, SectionRegistry } from './app-section.model';

// TODO label must contain a translatable string. See if it makes sense to do the translation in the component, in the service, or in the registry.
export const APP_SECTIONS: SectionRegistry = {
  [AppSection.DASHBOARD]: {
    navLink: {
      path: `/${AppSection.DASHBOARD}`,
      label: 'Dashboard',
      icon: 'dashboard_2',
    },
    strategy: () => import('../../pages/dashboard/dashboard-toolbar-strategy.adapter'),
  },
  [AppSection.CRM]: {
    navLink: {
      path: `/${AppSection.CRM}`,
      label: 'CRM',
      icon: 'contacts',
    },
    strategy: () => import('../../pages/crm/crm-toolbar-strategy.adapter'),
  },
  [AppSection.OPERATIONS]: {
    navLink: {
      path: `/${AppSection.OPERATIONS}`,
      label: 'Operaciones',
      icon: 'local_shipping',
    },
    strategy: () => import('../../pages/operations/operations-toolbar-strategy.adapter'),
  },
  [AppSection.INCOME]: {
    navLink: {
      path: `/${AppSection.INCOME}`,
      label: 'Ingresos',
      icon: 'request_quote',
    },
    strategy: () => import('../../pages/income/income-toolbar-strategy.adapter'),
  },
  [AppSection.OUTCOME]: {
    navLink: {
      path: `/${AppSection.OUTCOME}`,
      label: 'Gastos',
      icon: 'request_quote',
    },
    strategy: () => import('../../pages/outcome/outcome-toolbar-strategy.adapter'),
  },
  [AppSection.DCD]: {
    navLink: {
      path: `/${AppSection.DCD}`,
      label: 'DCD',
      icon: 'qr_code_scanner',
    },
    strategy: () => import('../../pages/dcd/dcd-toolbar-strategy.adapter'),
  },
  [AppSection.ADMIN]: {
    navLink: {
      path: `/${AppSection.ADMIN}`,
      label: 'Administración',
      icon: 'manage_accounts',
    },
    strategy: () => import('../../pages/admin/admin-toolbar-strategy.adapter'),
  },
  [AppSection.CONFIG]: {
    navLink: {
      path: `/${AppSection.CONFIG}`,
      label: 'Configuración',
      icon: 'settings',
    },
    strategy: () => import('../../pages/config/config-toolbar-strategy.adapter'),
  },
};
